import { NotesPage } from '@elsevier-health/osmosis-shared/types/notes';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import Image from 'next/image';

interface NotesPageNotesBlockProps {
  title: string;
  pages: NotesPage[];
  isFullscreen: boolean;
}

/**
 * Renders a block of notes pages with images.
 * @param {NotesPageNotesBlockProps} props - The props for the component.
 */
const NotesPageNotesBlock = ({
  title,
  pages,
  isFullscreen,
}: NotesPageNotesBlockProps) => {
  return (
    <Box className="flex w-full flex-col items-center">
      {pages.map((note: NotesPage, i: number) => {
        const isFirstPages = i < 2;
        return (
          <Box
            key={`${note.num}` + i + note?.id}
            className={`${isFullscreen ? 'w-full' : 'w-1/2'} px-[30px]`}
            data-testid={`page-${i + 1}`}
          >
            <Image
              alt={note.altText || `${title} (page ${i + 1})`}
              src={note.$ || note.svg || ''}
              fetchPriority={isFirstPages ? 'high' : 'low'}
              loading={isFirstPages ? 'eager' : 'lazy'}
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginBottom: '20px',
              }}
              width={184}
              height={238}
              onContextMenu={(e) => e.preventDefault()}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default NotesPageNotesBlock;
